import * as React from 'react';

function SvgUsers24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={30}
      height={24}
      fill='none'
      viewBox='0 0 30 24'
      {...props}
    >
      <path
        d='M1 22.6364V21.3637C1 19.0008 1.93863 16.7348 3.60941 15.064C5.28019 13.3932 7.54625 12.4546 9.90909 12.4546V12.4546C12.2719 12.4546 14.538 13.3932 16.2088 15.064C17.8795 16.7348 18.8182 19.0008 18.8182 21.3637V22.6364'
        stroke='black'
        strokeWidth='1.90909'
        strokeLinecap='round'
      />

      <path
        d='M16.2727 15C16.2727 13.3122 16.9432 11.6936 18.1366 10.5002C19.33 9.30681 20.9486 8.63635 22.6363 8.63635V8.63635C23.472 8.63635 24.2995 8.80095 25.0716 9.12075C25.8437 9.44056 26.5452 9.9093 27.1361 10.5002C27.727 11.0911 28.1958 11.7927 28.5156 12.5647C28.8354 13.3368 29 14.1643 29 15V15.6364'
        stroke='black'
        strokeWidth='1.90909'
        strokeLinecap='round'
      />

      <path
        d='M9.90902 12.4545C11.2592 12.4545 12.5541 11.9182 13.5088 10.9635C14.4636 10.0087 14.9999 8.71383 14.9999 7.36364C14.9999 6.01344 14.4636 4.71855 13.5088 3.76382C12.5541 2.80909 11.2592 2.27273 9.90902 2.27273C8.55883 2.27273 7.26394 2.80909 6.30921 3.76382C5.35448 4.71855 4.81812 6.01344 4.81812 7.36364C4.81812 8.71383 5.35448 10.0087 6.30921 10.9635C7.26394 11.9182 8.55883 12.4545 9.90902 12.4545V12.4545ZM22.6363 8.63636C23.6489 8.63636 24.6201 8.23409 25.3362 7.51804C26.0522 6.802 26.4545 5.83083 26.4545 4.81818C26.4545 3.80554 26.0522 2.83437 25.3362 2.11832C24.6201 1.40227 23.6489 1 22.6363 1C21.6237 1 20.6525 1.40227 19.9364 2.11832C19.2204 2.83437 18.8181 3.80554 18.8181 4.81818C18.8181 5.83083 19.2204 6.802 19.9364 7.51804C20.6525 8.23409 21.6237 8.63636 22.6363 8.63636Z'
        stroke='black'
        strokeWidth='1.90909'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default SvgUsers24;
